export default __webpack_public_path__ + "static/plan-enterprise1-78cb8df35f07be30fc6e8ffcd2c7371b.svg";